import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxGbUiKitModule } from '@geekbears/ngx-gb-ui-kit';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReactiveFormsModule } from '@angular/forms';
import { GbNgrxAuthBasicModule } from '@geekbears/gb-ngrx-auth-basic';

import { AuthenticationRoutingModule } from '@modules/authentication/presentation/authentication-routing.module';
import { RequestsTypeStoreModule } from '@modules/company-manager/requests-type/application';
import { MembershipStoreModule } from '@modules/company-manager/membership/application';
import {
  AccountSetupCompleteModal,
  ClientModals,
  CompanyManagerContainer,
  CompanyModals,
  ExportModal,
  MembershipModals,
  NotFoundPage,
  ProfileModals,
  RegularUserContainer,
  ReminderModals,
  RequestTypeModals,
  SingUpModalModal,
  SuperAdminContainer,
  ToggleComponent,
  UsersModals,
  HomeContainer,
  GoBackComponent,
  CpLogoComponent,
  NoRequestsComponent,
  LoaderComponent,
} from './presentation';
import { NgxPaginationModule } from 'ngx-pagination';
import {
  SuperAdminHomeEffectsModule,
  SuperAdminHomeStoreModule,
} from '@modules/super-admin/superadmin-home/aplication';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SuperAdminHomeServices } from '@modules/super-admin/superadmin-home/domain';
import { superAdminHomeServicesImpl } from '@modules/super-admin/superadmin-home/infrastructure';
import {
  CompanyStoreModule,
  CompanyEffectsModule,
} from '@modules/super-admin/company/application';
import { CompanyServices } from '@modules/super-admin/company/domain';
import { CompanyServicesImpl } from '@modules/super-admin/company/infrastructure';
import { RequestsServices } from '@modules/regular-user/requests/domain';
import { RequestsServicesImpl } from '@modules/regular-user/requests/infrastructure';
import { ApprovesServices } from '@modules/regular-user/approves/domain';
import { ApprovesServicesImpl } from '@modules/regular-user/approves/infrastructure';
import {
  RequestsStoreModule,
  RequestsEffectsModule,
} from '@modules/regular-user/requests/application';
import {
  ApprovesStoreModule,
  ApprovesEffectsModule,
} from '@modules/regular-user/approves/application';
import { HideOnRoleDirective } from 'src/app/hide-on-role.directive';
import { ShowOnRoleDirective } from 'src/app/show-on-role.directive';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { ProfileServices } from '@modules/regular-user/profile/domain';
import { ProfileServicesImpl } from '@modules/regular-user/profile/infrastructure';
import {
  ProfileEffectsModule,
  ProfileStoreModule,
} from '@modules/regular-user/profile/application';
import {
  UsersEffectsModule,
  UsersStoreModule,
} from '@modules/company-manager/users/application';

export * from './presentation';

const pages = [NotFoundPage];
const modals = [
  CompanyModals,
  ExportModal,
  SingUpModalModal,
  ProfileModals,
  AccountSetupCompleteModal,
  ReminderModals,
  MembershipModals,
  RequestTypeModals,
  UsersModals,
  ClientModals,
];
const containers = [
  HomeContainer,
  SuperAdminContainer,
  CompanyManagerContainer,
  RegularUserContainer,
];
const widgets = [
  CpLogoComponent,
  GoBackComponent,
  NoRequestsComponent,
  LoaderComponent,
  ToggleComponent,
];

@NgModule({
  declarations: [
    ...pages,
    ...containers,
    ...widgets,
    ...modals,
    HideOnRoleDirective,
    ShowOnRoleDirective,
  ],
  providers: [
    {
      provide: SuperAdminHomeServices,
      useClass: superAdminHomeServicesImpl,
    },
    {
      provide: CompanyServices,
      useClass: CompanyServicesImpl,
    },

    {
      provide: RequestsServices,
      useClass: RequestsServicesImpl,
    },
    {
      provide: ApprovesServices,
      useClass: ApprovesServicesImpl,
    },
    {
      provide: ProfileServices,
      useClass: ProfileServicesImpl,
    },
  ],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    AuthenticationRoutingModule,
    GbNgrxAuthBasicModule,
    NgxGbUiKitModule,
    NgxPaginationModule,
    RequestsTypeStoreModule,
    MembershipStoreModule,
    SuperAdminHomeStoreModule,
    SuperAdminHomeEffectsModule,
    CompanyStoreModule,
    CompanyEffectsModule,
    RequestsStoreModule,
    RequestsEffectsModule,
    ApprovesStoreModule,
    ApprovesEffectsModule,
    ProfileStoreModule,
    ProfileEffectsModule,
    UsersStoreModule,
    UsersEffectsModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    MatIconModule,
    MatTooltipModule,
  ],
  exports: [
    NgxGbUiKitModule,
    ...pages,
    ...containers,
    ...widgets,
    HideOnRoleDirective,
    ShowOnRoleDirective,
  ],
})
export class SharedModule {}
